export default __webpack_public_path__ + "static/media/canvas.8adda069.png";